// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2l68h","col":"styles_col__3euoJ"};